<template>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    permanent
    persistent
    width="400"
  >
    <AlertCategoriesList :onSelectCategory="onSelectCategory" />

    <RequestResponseSnackBar
      :value="showSuccessSnackBar"
      v-model="showSuccessSnackBar"
      text="Alerts updated successfully"
      color="green"
    />

    <RequestResponseSnackBar
      :value="showErrorSnackBar"
      v-model="showErrorSnackBar"
      text="Error in updating alerts"
      color="red"
    />

    <template v-slot:append>
      <v-btn
        flat
        rounded
        block
        color="primary"
        class="mb-4 flex-shrink-0"
        :loading="updateLoading"
        @click="onSaveAlerts"
      >
        Save
      </v-btn>
    </template>
  </v-navigation-drawer>
</template>
  
<script>
import { mapState, mapGetters } from "vuex";
import RequestResponseSnackBar from "../../../weather_routing/components/RequestResponseSnackBar.vue";
import AlertCategoriesList from "../../components/CategoriesList.vue";
export default {
  name: "CategoriesDrawer",
  components: {
    RequestResponseSnackBar,
    AlertCategoriesList,
  },
  props: {
    onSelectCategory: {
      type: Function,
      required: true,
    },
    onSaveAlerts: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      drawer: true,
      showSuccessSnackBar: false,
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapState("alerts", [
      "categories",
      "updateLoading",
      "alerts",
      "updateSuccess",
      "updateFailed",
    ]),
    ...mapGetters("alerts", ["filteredAlerts"]),
  },
  methods: {},
  watch: {
    updateSuccess: {
      handler(value) {
        if (value) {
          this.showSuccessSnackBar = true;
        }
      },
      deep: true,
    },
    updateFailed: {
      handler(value) {
        if (value) {
          this.showErrorSnackBar = true;
        }
      },
      deep: true,
    },
  },
};
</script>
  
<style scoped>
.v-list {
  background: white;
}

.v-navigation-drawer {
  background: white !important;
}
</style>
    
  
    
    